import { Typography } from '@mui/material';
import { Tooltip } from '~/components/Tooltip';

export const CardActionsTitleText = ({ title }: { title: string }) => {
  return (
    <Tooltip title={title} placement="bottom-start">
      <Typography
        sx={{
          fontWeight: 400,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          mb: '4px',
          pr: 1,
        }}
        variant="h5"
      >
        {title}
      </Typography>
    </Tooltip>
  );
};
